export default __webpack_public_path__ + "static/media/Key_Takeaways_SAVE_Mode.9797f935.png";